import React from "react";
import { makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  subTitle: {
    fontSize: 14,
    color: theme.palette.grey[500],
    marginTop: 16,
    fontWeight: 600,
  },
}));

interface Props {
  wholeLength: number;
  selectedLength: number;
}

const SelectedItems = ({ wholeLength, selectedLength }: Props) => {
  const classes = useStyles();
  return wholeLength ? (
    <div className={classes.subTitle}>
      Selected {selectedLength} / {wholeLength}
    </div>
  ) : (
    <div className={classes.subTitle}>Loading...</div>
  );
};

export default SelectedItems;
